import React from 'react'
import './InputSuggestion.css'
import { useTranslation } from 'react-i18next';

interface Champion {
  id: number;
  name: string;
  positions: string[];
  faction: string[];
  releaseYear: string[];
  src: string;
}

export const InputSuggestion = (props: any) => {
  const {winGame, gameOver, setInputValue, setChampsSuggested, champs, championDictionary, squareId, squareSelected, inputValue, isCorrectSquare} = props;
  const getSuggestions = (value: string) => {
    setInputValue(value);
    const lowercaseValue = value.toLowerCase();
  
    if (lowercaseValue !== "") {
      const filteredSuggestedChamps = champs
      .filter((champ: Champion) => champ.name.toLowerCase().includes(lowercaseValue) && !isChampionInDictionary(champ))
      .sort((a: Champion, b: Champion) => a.name.localeCompare(b.name));

      setChampsSuggested(filteredSuggestedChamps);
    } else {
      setChampsSuggested([]);
    }
  };

  const isChampionInDictionary = (champ: Champion) => {
    const championsInSquare = championDictionary[squareId] || [];
    return championsInSquare.some((existingChamp: Champion) => existingChamp.id === champ.id);
  };

  const { i18n, t } = useTranslation();
  return (
    <>
      {squareSelected && !gameOver && !isCorrectSquare ? (
          <input
              id="inputSuggestions"
              autoComplete="off"
              type="text"
              className='inputChamp'
              autoFocus
              value={inputValue.charAt(0).toUpperCase() + inputValue.slice(1).toLowerCase()}
              placeholder={t('input-suggestion.placeholder')}
              onChange={(e) => getSuggestions(e.target.value)}
          />
      ) : null}
      {gameOver && winGame !== 9? (
        <span className='spanLose'>{t('input-suggestion.spanLose')}</span>
      ) : winGame === 9 ? (
        <span className='spanWin'>{t('input-suggestion.spanWin')}</span>
      ) : isCorrectSquare || !squareSelected ? (
        <span className='spanStart'>{winGame=== 0 ? t('input-suggestion.spanStartEmpty') : t('input-suggestion.spanStart') }</span>
      ) : null} 
    </>
  )

}
